import { logService } from '@/shared/services/LogService';
import { onAnalyticsReady } from 'vue-analytics';
import { IUserHypermediaRepresentation } from '../contracts/UserContract';
class EventService {
    /**
     * See https://support.google.com/analytics/answer/1033068#Anatomy
     * @param eventCategory
     *      Name for grouping objects which we track
     * @param eventAction
     *      Name for the type of action which we wish to track
     * @param eventLabel
     *      Optional. Can be used to more closely identify an action (E.g. Viewed Account -> which account?)
     */
    public track(eventCategory: string, eventAction: string, eventLabel?: string) {
        try {
            if ((window as any).ga) {
                let fieldsObject = {
                    hitType: 'event',
                    eventCategory,
                    eventAction,
                    eventLabel
                };
                if (eventLabel) {
                    fieldsObject.eventLabel = eventLabel;
                }
                (window as any).ga('send', fieldsObject);
            }
        } catch (err) {
            logService.logError(err, 'Could not track GA event');
        }
    }

    public pageview(pageName: string) {
        try {
            if ((window as any).ga) {
                (window as any).ga('send', 'pageview', pageName);
            }
        } catch (err) {
            logService.logError(err, 'Could not track GA event');
        }
    }

    public setUserType(user: IUserHypermediaRepresentation) {
        onAnalyticsReady().then(() => {
            let type = 'Consultant';
            if (user.isFullViewer) {
                type = 'FullViewer';
            } else if (user.isTribeViewer) {
                type = 'HiveLead';
            } else if (user.isSectorViewer) {
                type = 'SectorLead';
            } else if (user.isAccountViewer) {
                type = 'AccountTeam';
            } else if (user.isCoacheeViewer) {
                type = 'Coach';
            }
            if ((window as any).ga) {
                (window as any).ga('set', 'dimension1', type);
            }
        });
    }
}

export const eventService = new EventService();
